import { j as i } from "../../../jsx-runtime-B3iL8JI7.js";
import * as c from "@radix-ui/react-dialog";
import { modalStyles as D } from "./Modal.styles.js";
import { headingIconOptions as F } from "./Modal.consts.js";
import r from "../../atoms/Button/Button.js";
import P from "../../atoms/Button/IconButton/IconButton.js";
import "@radix-ui/react-checkbox";
import "../../atoms/Checkbox/Checkbox.styles.js";
import "@fortawesome/pro-solid-svg-icons";
import h from "../../atoms/Icon/Icon.js";
import "../../../tailwindConfig/bclTwMerge.js";
import "@fortawesome/pro-duotone-svg-icons";
import "../../atoms/Loader/SYFLoader/SyfLoader.js";
import "../../atoms/ProgressIndicator/ProgressIndicator.styles.js";
import "react";
import "@radix-ui/react-select";
import R from "../../../utilities/tw.js";
import "../../atoms/TextField/TextField.styles.js";
import "../../atoms/TextLink/TextLink.styles.js";
import "../../atoms/Chip/Chip.styles.js";
import "@radix-ui/react-radio-group";
import "../../atoms/RadioItem/RadioItem.styles.js";
import E from "../Alert/Alert.js";
const si = ({
  primaryButton: e,
  secondaryButton: s,
  tertiaryButton: a,
  children: v,
  handleClose: o,
  isOpen: N,
  heading: S,
  headingIcon: m,
  subheading: p,
  alert: n,
  modalRef: k
}) => {
  const {
    closeIcon: y,
    iconButton: C,
    tertiaryButtonContainer: A,
    primarySecondaryButtonContainer: T,
    headingIcon: I,
    modalContent: L,
    modalOverlay: O,
    modalTitle: w,
    subheader: $,
    primarySecondaryButtons: x
  } = D, d = (l) => {
    var t, g, f, j;
    return {
      ...((t = l == null ? void 0 : l.buttonAnalytics) == null ? void 0 : t.pageFunction) && {
        "data-track-pagefunction": l.buttonAnalytics.pageFunction
      },
      ...((g = l == null ? void 0 : l.buttonAnalytics) == null ? void 0 : g.page) && {
        "data-track-page": l.buttonAnalytics.page
      },
      ...((f = l == null ? void 0 : l.buttonAnalytics) == null ? void 0 : f.title) && {
        "data-track-title": l.buttonAnalytics.title
      },
      ...((j = l == null ? void 0 : l.buttonAnalytics) == null ? void 0 : j.type) && {
        "data-track-type": l.buttonAnalytics.type
      }
    };
  };
  return /* @__PURE__ */ i.jsx(c.Root, { open: N, onOpenChange: o, modal: !0, children: /* @__PURE__ */ i.jsxs(c.Portal, { children: [
    /* @__PURE__ */ i.jsx(c.Overlay, { className: O }),
    /* @__PURE__ */ i.jsxs(c.Content, { className: L, ref: k, children: [
      n && /* @__PURE__ */ i.jsx("div", { className: o ? R`mr-12` : "", children: /* @__PURE__ */ i.jsx(
        E,
        {
          defaultOpen: !0,
          variant: n.variant,
          icon: n.icon,
          children: n.children
        }
      ) }),
      o && /* @__PURE__ */ i.jsx(
        P,
        {
          variant: "ghost",
          className: C,
          onClick: o,
          iconName: "close",
          "aria-label": "Close",
          children: /* @__PURE__ */ i.jsx(h, { icon: "xmark", className: y })
        }
      ),
      /* @__PURE__ */ i.jsxs("div", { className: "flex flex-col gap-2", children: [
        /* @__PURE__ */ i.jsxs(
          c.Title,
          {
            className: `${o && !n ? "pr-8" : ""} ${w}`,
            children: [
              m && /* @__PURE__ */ i.jsx(
                h,
                {
                  icon: F[m],
                  className: I
                }
              ),
              S
            ]
          }
        ),
        p && /* @__PURE__ */ i.jsx(c.Description, { className: $, children: p })
      ] }),
      /* @__PURE__ */ i.jsx("div", { children: v }),
      (e || s || a) && /* @__PURE__ */ i.jsxs(
        "div",
        {
          className: `${a ? "justify-between" : "justify-end"} flex flex-col-reverse flex-wrap sm:flex-row sm:flex-nowrap`,
          children: [
            a && /* @__PURE__ */ i.jsx("div", { className: A, children: /* @__PURE__ */ i.jsx(
              r,
              {
                disabled: a.disabled,
                onClick: a.onClick,
                variant: "ghost",
                isLoading: a.isLoading,
                loadingText: a.loadingText,
                ...d(a),
                children: a.label
              },
              a.label
            ) }),
            /* @__PURE__ */ i.jsxs("div", { className: T, children: [
              s && /* @__PURE__ */ i.jsx(
                r,
                {
                  disabled: s.disabled,
                  onClick: s.onClick,
                  variant: "outlined",
                  className: x,
                  isLoading: s.isLoading,
                  loadingText: s.loadingText,
                  ...d(s),
                  children: s.label
                },
                s.label
              ),
              e && /* @__PURE__ */ i.jsx(
                r,
                {
                  disabled: e.disabled,
                  onClick: e.onClick,
                  variant: "filled",
                  className: x,
                  isLoading: e.isLoading,
                  loadingText: e.loadingText,
                  ...d(e),
                  children: e.label
                },
                e.label
              )
            ] })
          ]
        }
      )
    ] })
  ] }) });
};
export {
  si as default
};
